import styled from 'styled-components';


type IconLayoutProps = {
	isOpen: boolean;
}

type HeaderContentProps = {
	justifyContent: string;
}

const Root = styled.div`
	position: relative;
	width: 100%;
	height: auto;
`;

const Header = styled.div`
	display: flex;
	padding: 8px 0;
	cursor: pointer;
`;

const ButtonLayout = styled.div`
	@media(max-width: 640px) {
		display: none;
	}
`;

const ContentLayout = styled.div``;

const IconLayout = styled.div`
	display: inline-flex;
	transform-origin: 50% 50%;
	transition: transform .2s ease-in-out;

	${(p: IconLayoutProps) => !p.isOpen && `
		transform: rotate(-90deg);
	`}
`;

const HeaderContent = styled.div`
	flex: 1 1 auto;
	display: flex;
	align-items: center;

	${(p: HeaderContentProps) => p.justifyContent && `
		justify-content: ${p.justifyContent};
	`}

	@media(max-width: 960px) {
		flex-flow: column nowrap;
		align-items: flex-start;
	}
`;

export {
	Root,
	Header,
	ButtonLayout,
	ContentLayout,
	IconLayout,
	HeaderContent,
};
